<template>
  <v-app>
    <div v-if="initialApiError" class="pa-4 initial-api-error">
      <v-alert
        type="error"
        variant="tonal"
        border="start"
        density="comfortable"
        icon="mdi-alert"
        closable
        @click:close="dismissInitialApiError"
      >
        {{ initialApiError }}
      </v-alert>
    </div>
    <router-view></router-view>
  </v-app>
</template>

<script>
import axios from "axios";
import { ISI_API_URL, CURRENT_ENV } from "./config";
import * as Chartist from "chartist";

export default {
  data() {
    return {
      user_data: { first_name: "Bob", is_admin: false },
      auth_response: {},
      Chartist: Chartist,
      initialApiError: "",
    };
  },
  methods: {
    dismissInitialApiError() {
      this.initialApiError = "";
    },
    get_user_data: function () {
      var vm = this;
      const final_url =
        window.location.origin +
        window.location.pathname +
        window.location.search;

      console.log("Auth Debug Info:");
      console.log("- Current Environment:", CURRENT_ENV);
      console.log("- API URL:", ISI_API_URL);
      console.log("- Final URL:", final_url);
      console.log("- Hostname:", window.location.hostname);

      axios
        .get(ISI_API_URL + "user", {
          params: {
            final_url: final_url,
            requested_resource: "isivideo/testloop",
            product_id: "none",
          },
          withCredentials: true,
        })
        .then(function (data) {
          console.log("Auth Success:", data.data);
          vm.$store.commit("update_user_data", data.data);
          vm.user_data = data.data;
          vm.auth_response = data;
          // Mark auth as initialized
          vm.$store.commit("set_auth_initialized", true);
        })
        .catch(function (err) {
          console.error("Auth Error:", err);
          // Mark auth as initialized even on error
          vm.$store.commit("set_auth_initialized", true);

          if (err.response && err.response.data) {
            console.error("Login URL:", err.response.data.login_url);
            console.error("Error Details:", err.response.data);

            if (typeof err.response.data.login_url != "undefined") {
              // Add a small delay to ensure console logs are visible
              setTimeout(() => {
                window.location.href = err.response.data.login_url;
              }, 100);
            }
          } else {
            console.error("Network error or API unavailable");
            vm.initialApiError = "API unavailable, please try again later.";
          }
        });
    },
  },
  created: function () {
    this.get_user_data();
  },
};
</script>

<style scoped>
.initial-api-error {
  position: fixed;
  top: 220px;
  left: 50%;
  transform: translateX(-50%);
  width: min(90vw, 720px);
  z-index: 4000;
}
</style>
